import { Form, FormInstance, Select } from "antd";
import SelectDropdownLgIcon from "../../../../../assets/icons/SelectDropdownLgIcon";
import { selectStringOption } from "../../../../../utils/utils";
import RatingFillIcon from "../_icons/RatingFillIcon";
import RatingIcon from "../_icons/RatingIcon";
import { QuestionTypeProps } from "../_types/type";

export default function RatingField({
  index,
  form,
  name,
}: QuestionTypeProps & { form: FormInstance<any>; name: string }) {
  const selectedRating = Form.useWatch([name, index, "rating_to_value"], form);

  return (
    <div className="mt-4 space-y-4">
      <div className="flex items-center gap-8">
        <Form.Item
          name={[index, "rating_to_value"]}
          className="mb-0"
          initialValue={5}
        >
          <Select
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 80 }}
            options={selectStringOption(
              [...Array(5)].map((_, i) => (i + 1).toString()),
              "number",
            )}
            // className="select-border-none"
          />
        </Form.Item>
        <span className="block">to</span>
        <Form.Item
          name={[index, "linear_scale_to"]}
          className="mb-0"
          initialValue={"star"}
        >
          <Select
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 80 }}
            options={[
              {
                value: "star",
                label: <RatingFillIcon />,
              },
            ]}
            // className="select-border-none"
          />
        </Form.Item>
      </div>
      <div className="max-w-[50%] mx-auto flex justify-between">
        {[...Array(selectedRating)].map((_, i) => (
          <div className="flex flex-col items-center gap-2.5">
            <span className="block text-display-body">{i + 1}</span>
            <RatingIcon />
          </div>
        ))}
      </div>
    </div>
  );
}
